document.addEventListener('DOMContentLoaded', function () {
  const isLoggedIn = !!window.customerLoggedIn;

  // --- BOTONES DE WISHLIST ---
  document.querySelectorAll('.wishlist-button').forEach(function (button) {
    if (!isLoggedIn) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        alert('Para guardar productos en tu wishlist necesitas iniciar sesión');
      });
      return;
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      this.classList.toggle('active');

      const productHandle = this.dataset.handle;
      if (productHandle) {
        let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');

        if (this.classList.contains('active')) {
          if (!wishlist.includes(productHandle)) {
            wishlist.push(productHandle);
          }
        } else {
          wishlist = wishlist.filter(item => item !== productHandle);
        }

        localStorage.setItem('wishlist', JSON.stringify(wishlist));
      }
    });

    const handle = button.dataset.handle;
    const stored = JSON.parse(localStorage.getItem('wishlist') || '[]');
    if (stored.includes(handle)) {
      button.classList.add('active');
    }
  });

  // --- BOTÓN "AÑADIR AL CARRITO" JUNTO AL CORAZÓN (product-item) ---
  // No debe preventDefault() aquí: el click en el botón de submit tiene
  // que seguir disparando el envío del formulario (AJAX, manejado por
  // component-product-form.js) o la apertura del quick-view en productos
  // con variantes (component-quick-buy.js) — solo hace falta impedir que
  // el click suba hasta el <a> de la imagen que lo envuelve y navegue a
  // la ficha de producto, igual que ya se hace con el corazón.
  document.querySelectorAll('.product-item__cart-button-wrapper').forEach(function (wrapper) {
    wrapper.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  // --- PÁGINA DE WISHLIST ---
  const container = document.getElementById('wishlist-products');
  if (!container) return;

  if (!isLoggedIn) {
    container.innerHTML = `<p class="empty-msg">Inicia sesión para ver tu lista de favoritos</p>`;
    return;
  }

  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  if (!wishlist || wishlist.length === 0) {
    container.innerHTML = `<p class="empty-msg">Tu lista de favoritos está vacía</p>`;
    return;
  }

  container.innerHTML = '';

  wishlist.forEach(handle => {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        const title = product.title;
        const price = (product.price / 100).toFixed(2).replace('.', ',');
        const image = product.featured_image.startsWith('//')
          ? 'https:' + product.featured_image.split('?')[0]
          : product.featured_image.split('?')[0];

        const html = `
          <div class="grid__item">
            <div class="product-item card2" data-js-product-item>
              <a href="/products/${handle}" class="card__image product-item__image product-item__image--has-secondary" style="padding-top:100%; position: relative;">
                <figure class="product-item__image-figure" style="padding-top:100%; margin: 0;">
                  <img src="${image}" alt="${title}" class="img" loading="lazy" width="480" height="480"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; object-fit: cover; border-radius: 6px;">
                </figure>
              </a>

              <div class="wishlist-button active" data-handle="${handle}">
                <svg class="icon icon-heart" viewBox="0 0 290 256" xmlns="http://www.w3.org/2000/svg">
                  <path d="M258.8 127.8L145 241.6 31.2 127.8c-26.9-26.9-26.9-70.6 0-97.6 26.9-26.9 70.6-26.9 97.6 0L145 46.5l16.3-16.3c26.9-26.9 70.6-26.9 97.6 0 26.9 26.9 26.9 70.6 0 97.6z" stroke-width="20" fill-rule="evenodd"/>
                </svg>
              </div>

              <div class="card__text product-item__text gutter--small spacing--xlarge remove-empty-space text-align--left">
                <div>
                  <a class="product-item__title" href="/products/${handle}" title="${title}">
                    <div class="product-item__title-price-wrapper" style="display: flex; justify-content: space-between; align-items: center;">
                      <div class="product-item__title" style="flex-grow: 1;">${title}</div>
                      <div class="product-item__price">
                        <div class="product-price">
                          <span class="product-price--original">€${price}</span>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>

              <div class="text-align--center" style="margin-bottom: 30px;">
                <button class="remove-from-wishlist button button--small" data-handle="${handle}">Eliminar</button>
              </div>
            </div>
          </div>
        `;
        container.insertAdjacentHTML('beforeend', html);
      })
      .catch(err => console.error("Error cargando producto", handle, err));
  });

  container.addEventListener('click', function (e) {
    if (e.target.classList.contains('remove-from-wishlist')) {
      const handle = e.target.dataset.handle;
      let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
      wishlist = wishlist.filter(item => item !== handle);
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
      e.target.closest('.grid__item').remove();

      if (wishlist.length === 0) {
        container.innerHTML = '<p class="empty-msg">Tu lista de favoritos está vacía</p>';
      }
    }
  });
});